import _wx from "weixin-js-sdk";
import {
  getWechatConfig,
  wechatAuth,
  shareFail as shareFailApi
} from "@api/public";
import { parseQuery } from "@utils";
import cookie from "@utils/store/cookie";
import store from "@/store";
// import toLogin from "./login";
const WX_AUTH = "wx_auth";
const STATE_KEY = "wx_authorize_state";
const BACK_URL = "login_back_url";
let instance;
let wechatObj;
const SHARE_UID_KEY = "share-uid";
// let isIOS = /^.*((iPhone)|(iPad)|(Safari))+.*$/.test(navigator.userAgent);
let system = {
  win: false,
  mac: false,
  xll: false,
  ipad: false
};
//检测平台
let p = navigator.platform;
system.win = p.indexOf("Win") == 0;
system.mac = p.indexOf("Mac") == 0;
system.x11 = p == "X11" || p.indexOf("Linux") == 0;
system.ipad = navigator.userAgent.match(/iPad/i) != null ? true : false;
//跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面
let isPcOpen = false,
  isWeixinMobileOpen = false,
  isOtherOpen = false;
if (system.win || system.mac || system.xll || system.ipad) {
  isPcOpen = true;
} else {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    isWeixinMobileOpen = true;
  } else {
    isOtherOpen = true;
    console.log("isOtherOpen", isOtherOpen, isPcOpen);
  }
}

export default function wechat() {
  return new Promise((resolve, reject) => {
    getWechatConfig()
      .then(({ data }) => {
        _wx.config(data);
        _wx.ready(() => {
          resolve(data);
        });
        _wx.error(res => {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          reject(res);
        });
      })
      .catch(err => {
        reject(err);
        // alert("getWechatConfig:err=" + err);
        // location.reload();
      });
  });
}

export function clearAuthStatus() {
  cookie.remove(STATE_KEY);
}

export function oAuth() {
  if (
    store.state.app.token &&
    store.state.app.userInfo &&
    store.state.app.userInfo.openid &&
    store.state.app.userInfo.openid.length > 20
  )
    return;
  const { code } = parseQuery();
  console.log("授权回来", code);
  if (!code) return toAuth();
}

export function auth(code, state) {
  let urlBack = cookie.get(BACK_URL) || `${location.origin}/`;
  cookie.remove(BACK_URL);

  if (cookie.get(WX_AUTH) == code) {
    if (urlBack) location.href = urlBack;
    return;
  }
  cookie.set(WX_AUTH, code, 1 / 240);

  let parent_id = store.state.app.share_uid;
  let flag = 0;
  if (!parent_id) {
    parent_id = cookie.get(SHARE_UID_KEY) || 0;
    if (parent_id) flag = 1;
  }
  let param = { code, state, parent_id, flag, back_url: urlBack };
  wechatAuth(param)
    .then(({ data }) => {
      if (data) {
        store.commit("UPDATE_USERINFO", data);
      }
      if (urlBack) location.href = urlBack;
    })
    .catch(err => {
      console.log(err, "wechatAuth-catch-3000");
      // setTimeout(() => {
      //   location.replace("/");
      // }, 3000);
    });
}

export function toAuth() {
  wechat()
    .then(({ appId }) => {
      location.href = getAuthUrl(appId);
    })
    .catch(err => {
      console.log("toAuth", err);
    });
}

export function shareFail(data) {
  let param = {};
  if (data) param["data"] = data;
  param["href"] = location.href;
  return shareFailApi(param);
}

function getAuthUrl(appId) {
  let backUrl = cookie.get(BACK_URL) || location.pathname + location.search;
  const redirect_uri = encodeURIComponent(`${location.origin}/auth/`);

  // redirect_uri = redirect_uri || encodeURIComponent(`${location.origin}/`);
  cookie.set(BACK_URL, backUrl, 1 / 48);
  const state = encodeURIComponent(
    ("" + Math.random()).split(".")[1] + "_authorizestate"
  );
  cookie.set(STATE_KEY, state);
  let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${state}&connect_redirect=1#wechat_redirect`;
  return url;
}

export function pay(config) {
  // alert(
  //   "真艾商城因销售火爆，订单爆仓，系统暂时停止接单，待恢复接单之后继续交易，已经购买的订单正常发货，给您造成的不便敬请谅解。"
  // );
  // return;
  return new Promise((resolve, reject) => {
    let WeixinJSBridge = WeixinJSBridge || window.WeixinJSBridge || null;
    WeixinJSBridge.invoke("getBrandWCPayRequest", config, res => {
      console.log("getBrandWCPayRequest:", res);
      switch (res.err_msg) {
        case "get_brand_wcpay_request:ok":
          return resolve(res);
        default:
          return reject(res);
      }
    });

    // config['timeStamp'] *= 1
    // console.log('pay-config',config)
    // _wx.chooseWXPay({
    //   ...config,
    //   success: (res)=> {
    //     // 支付成功后的回调函数
    //     console.log('pay-res',res)
    //     resolve(res)
    //   },
    //   fail:(err)=>{
    //     alert(JSON.stringify(config))
    //     reject(err);
    //   }
    // });
  });
}

export async function openAddress() {
  return new Promise((resolve, reject) => {
    wechat().then(() => {
      _wx.openAddress({
        fail(res) {
          reject(res);
        },
        success(res) {
          resolve(res);
        }
      });
    });
    // instance.openAddress({
    //   fail(res) {
    //     reject(res);
    //   },
    //   success(res) {
    //     resolve(res);
    //   }
    // });
  });
}

export function openShareAll(config) {
  config || {};
  config.type = config.type == undefined ? "link" : config.type;
  return new Promise(resolve => {
    getWechatConfig()
      .then(res => {
        wechatObj.signSignature({
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          timestamp: res.data.timestamp
        });
        instance = wechatObj.getOriginalWx();
        instance.ready(() => {
          instance.updateAppMessageShareData(config);
          instance.updateTimelineShareData(config);
          resolve();
        });
      })
      .catch(err => {
        console.log(err);
      });
  });
}

export function openShareAppMessage(config) {
  instance.updateAppMessageShareData(config);
  instance.onMenuShareAppMessage && instance.onMenuShareAppMessage(config);
}

export function openShareTimeline(config) {
  instance.updateTimelineShareData(config);
  instance.onMenuShareTimeline && instance.onMenuShareTimeline(config);
}

/**
 * 公众号事件
 * @param name 事件名
 * @param config 配置
 * @returns {Promise<unknown>}
 */
export function wechatEvevt(name, config) {
  return new Promise(resolve => {
    let configDefault = {
      fail(res) {
        // alert('微信配置错误(1)：'+JSON.stringify(res)+','+(typeof Object.assign))
        console.log("res", res);
        if (isWeixinMobileOpen) {
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        }
        // if (wx) return reject({ is_ready: true, wx: wx });
        // getWechatConfig().then(res => {
        //   wechatObj.signSignature({
        //     nonceStr: res.data.nonceStr,
        //     signature: res.data.signature,
        //     timestamp: res.data.timestamp
        //   });
        //   wx = wechatObj.getOriginalWx();
        //   reject({ is_ready: true, wx: wx });
        // });
      },
      success(res) {
        resolve(res);
      }
    };
    Object.assign(configDefault, config);

    wechat().then(() => {
      if (typeof name === "object") {
        name.forEach(item => {
          _wx[item] && _wx[item](configDefault);
        });
      } else _wx[name] && _wx[name](configDefault);
    });

    // getWechatConfig().then(res => {
    //   const _wx = WechatJSSDK(res.data);
    //   _wx
    //     .initialize()
    //     .then(() => {
    //       instance = _wx.getOriginalWx();
    //       instance.ready(() => {
    //         if (typeof name === "object") {
    //           name.forEach(item => {
    //             instance[item] && instance[item](configDefault);
    //           });
    //         } else instance[name] && instance[name](configDefault);
    //       });
    //     })
    //     .catch(err => {
    //       alert("微信配置错误(0)：" + JSON.stringify(err));
    //       console.log("res", res);
    //
    //       // window.location.reload();
    //     });
    // });
  });
}

// export function ready() {
//   return new Promise(resolve => {
//     if (typeof instance !== "undefined") {
//       instance.ready(() => {
//         resolve(instance);
//       });
//     } else {
//       getWechatConfig().then(res => {
//         const _wx = WechatJSSDK(res.data);
//         _wx.initialize().then(() => {
//           instance = _wx.wx;
//           instance.ready(() => {
//             resolve(instance);
//           });
//         });
//       });
//     }
//   });
// }
